export const shuffleArray = (arr: Array<unknown>) => {
  const shuffledArray = arr
    .map((a) => ({ sort: Math.random(), value: a }))
    .sort((a, b) => a.sort - b.sort)
    .map((a) => a.value)
  return shuffledArray
}
